// Console theme control. The design system (console-ui.css) defines both light
// and dark via --ui-* tokens; this drives which one is active by stamping
// data-theme on <html>. Default (no saved choice) follows the OS.
const KEY = 'bioweave_console_theme';
export type Theme = 'light' | 'dark';

export function initialTheme(): Theme {
  const saved = globalThis.localStorage?.getItem(KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  return globalThis.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(t: Theme): void {
  document.documentElement.setAttribute('data-theme', t);
}

export function saveTheme(t: Theme): void {
  globalThis.localStorage?.setItem(KEY, t);
  applyTheme(t);
}
